import { useParams } from "react-router-dom";
import Intervju from "@/pages/Intervju";
import { Leaf } from "lucide-react";

export default function IntervjuDelad() {
  const { token } = useParams();
  return (
    <div className="min-h-screen bg-muted/30">
      <header className="border-b border-border bg-white">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center gap-2">
          <div className="h-8 w-8 rounded-lg bg-primary flex items-center justify-center text-primary-foreground">
            <Leaf className="h-4 w-4" />
          </div>
          <span className="font-head font-bold">HAMN CV Studio</span>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-8">
        <Intervju shared token={token} />
      </main>
    </div>
  );
}
